import { Component, Element, Host, Prop, Watch, h } from '@stencil/core';
import { renderTools } from '../../helpers/RenderTools';
import { renderStandardTeaserErrorMessages } from '../../helpers/helpers';
import type { CssClassMap, Teaser } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-standard-teaser',
  styleUrl: 'cms-standard-teaser.scss',
  shadow: true,
})
export class CmsStandardTeaser {
  private teaserResult: Teaser[];

  private readonly imageSizes = `
  (min-width:768px) and (max-width: 1279px) 50vw,
  (min-width:1280px) 368px,
  100vw`;

  /**
   * is true only has background image
   * */
  @Prop() backgroundImage: string;

  /**
   * is true only in cms preview
   */
  @Prop() isPreview: false;

  /**
   * set the headline
   */
  @Prop() headline: '';

  /**
   * set label show more text
   */
  @Prop() moreInfoLabel: '';

  /**
   * set download pdf label like zum pdf document
   */
  @Prop() downloadPdfLabel: '';

  /**
   * set the teaser content
   */
  @Prop() teaserData: Teaser | string;

  @Watch('teaserData')
  private teaserWatcher(newValue: string | Teaser) {
    if (newValue) {
      this.teaserResult =
        typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
    }
  }

  @Element() hostElement: HTMLElement;

  private mapTeaserResult(teaserList: Teaser[]) {
    if (this.teaserResult.length === 0) {
      return;
    }

    return teaserList?.map((teaser: Teaser) => {
      if (this.isPreview && teaser.previewErrors) {
        return renderStandardTeaserErrorMessages(teaser.previewErrors);
      }

      if (!teaser.previewErrors) {
        const teaserWithAltText = {
          ...teaser,
          altText: '',
        };
        return (
          <cms-teaser
            teaser={teaserWithAltText}
            imageSizes={this.imageSizes}
            moreInfoLabel={this.moreInfoLabel}
            downloadPdfLabel={this.downloadPdfLabel}
          />
        );
      }
    });
  }

  private hostClassMap(): CssClassMap {
    return {
      'dynamic-teasers': true,
    };
  }

  connectedCallback() {
    if (this.teaserData) {
      this.teaserWatcher(this.teaserData);
    }
  }

  componentWillLoad() {
    if (this.backgroundImage) {
      this.hostElement.classList.add('has-bg');
    }
  }

  render() {
    return (
      <Host
        class={this.hostClassMap()}
        style={{
          padding: this.backgroundImage ? '2rem 0' : '',
          backgroundImage: this.backgroundImage
            ? `url(${renderTools.getBgImageSrc(this.backgroundImage)})`
            : null,
          backgroundRepeat: 'repeat',
        }}
      >
        <div class={'teaser-list-container dynamic-teasers'}>
          <div class={'teaser-headline'}>
            <cms-headline
              style={{ '--cms-spacing-top': '0' }}
              headlineText={this.headline}
              headlineTag='h2'
              headlineClass={'standard-teaser-headline'}
              headlinePosition='center'
              layout='full'
              isAdaptive
            />
          </div>
          <div class={'teaser-list-container-inner'}>
            {this.mapTeaserResult(this.teaserResult)}
          </div>
        </div>
      </Host>
    );
  }
}
